import { connect } from 'react-redux'
import { clearLookupData, setTargetComponent } from 'Modules/lookups/actions'
import {
  openRegisterModal,
  openLoginModal,
  openEmailVerifyModal,
  openEditFavouritesModal,
} from 'Modules/modals/actions'
import { getUserIsOneOfAgentAdminSupport } from 'Modules/user/data/selectors'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import { toggleFavListing } from 'Modules/user/favourites/actions'
import ListingPreview from './ListingPreview'

// extract reuiqred props for listing preview
export const extractListingPreviewProps = (listing) => ({
  key: listing.id + listing.title,
  id: listing.id,
  listing,
  title: listing.title,
  url: listing.url,
  subtitle: listing.neighbourhood_name || listing.locality_name,
  askingPrice: listing.asking_price,
  bathrooms: listing.bathrooms,
  parkingSpots: listing.parking_spots,
  mlsNumber: listing.mls_number,
  photoBaseUrl: listing.photo_base_url,
  photoCount: listing.photo_count,
  status: listing.status,
  offer: listing.offer,
  maintenanceFee: listing.maintenance_fee ? parseFloat(listing.maintenance_fee) : 0,
  slogan: listing.slogan,
  sqftMin: listing.sqft_min,
  sqftMax: listing.sqft_max,
  sqft: listing.sqft,
  createdAt: listing.created_at,
  addressId: listing.address_id,
  bedType: listing.bed_type,
  propertyType: listing.property_type,
  bannerId: listing.banner_id,
  brokerage: listing.brokerage,
  closedPrice: listing.closed_price,
  endDateUnix: listing.end_date_unix,
  photoVersion: listing.photo_version,
  sqftSource: listing.sqft_source,
  entryDateUnix: listing.entry_date_unix,
  tourUrl: listing.tour_url,
  photoSource: listing.photo_source,
})

const mapStateToProps = state => ({
  hasMyAgent: !!state.userData.myAgent,
  userIsLoggedIn: state.userData.userIsAuthentificated,
  mobileBrowser: state.app.mobileBrowser,
  userFavs: state.userFavourites.userFavs,
  userEmailVerified: state.userData.user.emailVerified,
  userIsOneOfAgentAdminSupport: getUserIsOneOfAgentAdminSupport(state),
  isMobileApp: state.app.isMobileApp,
})
const actions = {
  clearLookupData,
  openRegister: openRegisterModal,
  openLogin: openLoginModal,
  toggleFav: toggleFavListing,
  setTargetComponent,
  openEmailVerifyModal,
  openEditFavouritesModal,
  googleAnalyticsEvent,
}

export default connect(mapStateToProps, actions)(ListingPreview)
